import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsNotEmpty, IsString, IsUUID } from 'class-validator';
import { PromotionTtlUserExposeGroup } from '../interface';
export class ReadPromotionTtlUserDto {
}
__decorate([
    ApiProperty({ type: () => String, description: 'merchantId ', example: 'BAREBURGER_GROUP' }),
    Expose({ groups: [PromotionTtlUserExposeGroup.READ] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadPromotionTtlUserDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: () => String, format: 'string', description: 'UserId', example: '000080877816155' }),
    Expose({ groups: [PromotionTtlUserExposeGroup.READ] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadPromotionTtlUserDto.prototype, "userId", void 0);
__decorate([
    ApiProperty({
        type: () => String,
        format: 'uuid',
        description: 'uuid(v4), merchant-level promotion uuid ',
        example: 'a6856553-81f5-4cbe-ac6e-76c043a790fd',
    }),
    Expose({ groups: [PromotionTtlUserExposeGroup.READ] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    IsUUID('4', { always: true }),
    __metadata("design:type", String)
], ReadPromotionTtlUserDto.prototype, "promotionUuid", void 0);
__decorate([
    ApiProperty({ type: () => Date, format: 'date-time', description: 'date this offer will expire', example: 'ISODate("2018-09-04T06:45:41.716+0000")' }),
    Expose({ groups: [PromotionTtlUserExposeGroup.READ, PromotionTtlUserExposeGroup.CREATE] }),
    Type(() => Date),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", Date)
], ReadPromotionTtlUserDto.prototype, "expireAt", void 0);
//# sourceMappingURL=ReadPromotionTtlUserDto.js.map